module.exports = __webpack_public_path__ + "img/404.499bb8db.png";